import { useEffect, useState } from 'react';
import { isFeatureEnabled, subscribeToRemoteConfigUpdates } from 'firebase';

const readFeatureFlag = (
  featureName: Parameters<typeof isFeatureEnabled>[0]
) => {
  try {
    return isFeatureEnabled(featureName);
  } catch {
    return false;
  }
};

export const useRemoteFeatureFlag = (
  featureName: Parameters<typeof isFeatureEnabled>[0]
) => {
  const [enabled, setEnabled] = useState(() => readFeatureFlag(featureName));

  useEffect(() => {
    setEnabled(readFeatureFlag(featureName));

    return subscribeToRemoteConfigUpdates(() => {
      setEnabled(readFeatureFlag(featureName));
    });
  }, [featureName]);

  return enabled;
};
